/**
 * GENERATED CODE - DO NOT MODIFY
 */
import { type HeadersMap, XRPCError } from '@atproto/xrpc'
import { type ValidationResult, BlobRef } from '@atproto/lexicon'
import { CID } from 'multiformats/cid'
import { validate as _validate } from '../../../../lexicons.js'
import {
  type $Typed,
  is$typed as _is$typed,
  type OmitKey,
} from '../../../../util.js'
import type * as ChatBskyConvoDefs from './defs.js'

const is$typed = _is$typed,
  validate = _validate
const id = 'chat.bsky.convo.listConvos'

export type QueryParams = {
  limit?: number
  cursor?: string
  readState?: 'unread' | (string & {})
  /** Filter convos by their status. It is discouraged to call with "request" and preferred to call chat.bsky.convo.listConvoRequests, which also includes group join requests made by the user. */
  status?: 'request' | 'accepted' | (string & {})
  /** Filter by conversation kind. */
  kind?: 'direct' | 'group' | (string & {})
  /** Filter by conversation lock status. Values follow chat.bsky.convo.defs#convoLockStatus. */
  lockStatus?: 'unlocked' | 'locked' | 'locked-permanently' | (string & {})
}
export type InputSchema = undefined

export interface OutputSchema {
  cursor?: string
  convos: ChatBskyConvoDefs.ConvoView[]
}

export interface CallOptions {
  signal?: AbortSignal
  headers?: HeadersMap
}

export interface Response {
  success: boolean
  headers: HeadersMap
  data: OutputSchema
}

export function toKnownErr(e: any) {
  return e
}
